import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, ListGroup, Spinner, Card, Image, Button } from 'react-bootstrap';
import { getProductByVersion } from '../../actions';
import { useLocation } from 'react-router-dom';
import ViewModal from './ViewModal';
import VersionDiffModal from './VersionDiffModal';
import { FaCodeBranch } from 'react-icons/fa';

class SESProductViewVersions extends Component {
  state = {
    selectedVersion: null,
    showModal: false,
    showDiffModal: false,
    diffVersions: {
      old: null,
      new: null
    }
  };

  componentDidMount() {
    const { location } = this.props;
    const searchParams = new URLSearchParams(location.search);
    const product_code = searchParams.get('product_code');
    if (product_code) {
      this.props.getProductByVersion(product_code);
    }
  }

  handleVersionSelect = (version) => {
    this.setState({
      selectedVersion: version
    });
  };

  handleShowDiff = (oldVersion, newVersion) => {
    this.setState({
      showDiffModal: true,
      diffVersions: {
        old: oldVersion,
        new: newVersion
      }
    });
  };

  render() {
    const { versions, loading, error } = this.props;
    const { location } = this.props;
    const searchParams = new URLSearchParams(location.search);
    const product_code = searchParams.get('product_code');
    const productVersions = versions[product_code] || [];
    const { selectedVersion, showModal, showDiffModal, diffVersions } = this.state;

    if (loading) {
      return (
        <div className="text-center mt-5">
          <Spinner animation="border" variant="primary" />
          <p>Loading versions...</p>
        </div>
      );
    }

    if (error) {
      return <div className="alert alert-danger mt-3">{error}</div>;
    }

    return (
      <Container fluid>
        <h2 className="text-center mb-4">Product Versions: {product_code}</h2>
        <Row>
          <Col md={4}>
            <h4>Version List</h4>
            <ListGroup>
              {productVersions.map((version, index) => (
                <ListGroup.Item 
                  key={index}
                  action
                  active={selectedVersion && selectedVersion._id === version._id}
                  onClick={() => this.handleVersionSelect(version)}
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <div>Version: {version.version}</div>
                      {version.friendly_version && (
                        <small className="text-muted">
                          {version.friendly_version}
                        </small>
                      )}
                      {index < productVersions.length - 1 && (
                        <Button
                          variant="link"
                          size="sm"
                          className="p-0 d-block"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.handleShowDiff(productVersions[index + 1], version);
                          }}
                          title="Compare with previous version"
                        >
                          <FaCodeBranch /> Compare with previous version
                        </Button>
                      )}
                    </div>
                    <div className="text-end">
                      <small className="text-muted d-block">
                        Updated: {new Date(version.updated_at).toLocaleString()}
                      </small>
                      <small className="text-muted d-block">
                        By: {version.updated_by || 'System'}
                      </small>
                    </div>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Col>
          <Col md={8}>
            {selectedVersion ? (
              <Card>
                <Card.Body>
                  <Row>
                    <Col md={4}>
                      {selectedVersion.images && selectedVersion.images.length > 0 && (
                        <div>
                          {selectedVersion.images.map((img, idx) => (
                            <div className="mb-3" key={idx}>
                              <Image
                                src={img.image_link}
                                alt={selectedVersion.product_name}
                                fluid
                                style={{ width: '100%', height: 'auto' }}
                              />
                            </div>
                          ))}
                        </div>
                      )}
                    </Col>
                    <Col md={8}>
                      <h4>{selectedVersion.product_name}</h4>
                      <div className="mb-3">
                        <strong>SKU Code:</strong> {selectedVersion.sku_code}
                      </div>
                      <div className="mb-3">
                        <strong>Product Code:</strong> {selectedVersion.product_code}
                      </div>
                      <div className="mb-3">
                        <strong>Version:</strong> {selectedVersion.version}
                      </div>
                      <div className="mb-3">
                        <strong>Friendly Version:</strong> {selectedVersion.friendly_version}
                      </div>
                      <div className="mb-3">
                        <strong>Updated By:</strong> {selectedVersion.updated_by || 'System'}
                      </div>
                      <div className="mb-3">
                        <strong>Last Updated:</strong> {new Date(selectedVersion.updated_at).toLocaleString()}
                      </div>
                      <div className="mb-3">
                        <strong>Style:</strong> {selectedVersion.style}
                      </div>
                      <div className="mb-3">
                        <strong>Size:</strong> {selectedVersion.size}
                      </div>
                      <div className="mb-3">
                        <strong>Base Price (VND):</strong> ${selectedVersion.base_price_vnd}
                      </div>
                      <div className="mb-3">
                        <strong>Default Quantity:</strong> {selectedVersion.default_quantity}
                      </div>
                      {selectedVersion.properties && (
                        <>
                          <h5 className="mt-4">Properties</h5>
                          <div className="mb-3">
                            <strong>Material:</strong> {selectedVersion.properties.material}
                          </div>
                          <div className="mb-3">
                            <strong>Color:</strong> {selectedVersion.properties.color}
                          </div>
                          <div className="mb-3">
                            <strong>Note:</strong> {selectedVersion.properties.note}
                          </div>
                          <div className="mb-3">
                            <strong>Dimensions:</strong> {selectedVersion.properties.length_mm}mm x {selectedVersion.properties.width_mm}mm x {selectedVersion.properties.height_mm}mm
                          </div>
                          <div className="mb-3">
                            <strong>Weight:</strong> {selectedVersion.properties.weight_g}g
                          </div>
                        </>
                      )}
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            ) : (
              <div className="text-center text-muted mt-5">
                Select a version from the list to view details
              </div>
            )}
          </Col>
        </Row>
        {selectedVersion && (
          <ViewModal
            show={showModal}
            onClose={() => this.setState({ showModal: false })}
            currentProduct={selectedVersion}
            mode="view"
          />
        )}
        <VersionDiffModal
          isOpen={showDiffModal}
          toggle={() => this.setState({ showDiffModal: false })}
          oldVersion={diffVersions.old}
          newVersion={diffVersions.new}
        />
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  versions: state.sesProductVersionReducer.versions,
  loading: state.sesProductVersionReducer.loading,
  error: state.sesProductVersionReducer.error
});

// Wrap with router params
const SESProductViewVersionsWithRouter = (props) => {
  const location = useLocation();
  return <SESProductViewVersions {...props} location={location} />;
};

export default connect(mapStateToProps, {
  getProductByVersion
})(SESProductViewVersionsWithRouter); 